import { type IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import {
  HeaderMainNavigation,
  DynamicStudentLogo,
  DynamicTeacherLogo,
} from "@kunduz/ui-components";
import { useRouter } from "next/router";
import { DesktopRightLoader } from "./desktopRightLoader";
import { useAppContext } from "@kunduz/feature-website-context";
import { MobileBottomLoader } from "./mobileBottomLoader";
import { MobileRightLoader } from "./mobileRightLoader";
import { MobileLogoLoader } from "./mobileLogoLoader";
import { MobileTopLoader } from "./mobileTopLoader";
import { DesktopLeftLoader } from "./desktopLeftLoader";

export const DynamicHeader = (props: Props): ReactElement => {
  const router = useRouter();
  const { kunduzApiToken } = useAppContext();

  const desktopLeftItems = props.headerItems?.components?.filter(
    (x) => x.data?.desktop_position == "left",
  );
  const desktopRightItems = props.headerItems?.components?.filter(
    (x) => x.data?.desktop_position == "right",
  );
  const mobileTopItems = props.headerItems?.components?.filter(
    (x) => x.data?.mobile_position == "top",
  );
  const mobileRightItems = props.headerItems?.components?.filter(
    (x) => x.data?.mobile_position == "right",
  );
  const mobileBottomItems = props.headerItems?.components?.filter(
    (x) => x.data?.mobile_position == "bottom",
  );

  return (
    <HeaderMainNavigation
      logoComponent={
        props.headerType == "teacher" ? (
          <DynamicTeacherLogo
            mini={!!kunduzApiToken}
            linkPath={props.lang == "tr" ? "/tr/" : "/"}
          />
        ) : (
          <DynamicStudentLogo linkPath={props.lang == "tr" ? "/tr/" : "/"} />
        )
      }
      desktopLeftComponent={
        <DesktopLeftLoader
          headerType={props.headerType}
          desktopLeftCmsData={desktopLeftItems}
        />
      }
      desktopRightComponent={
        <DesktopRightLoader
          headerType={props.headerType}
          desktopRightCmsData={desktopRightItems}
        />
      }
      mobileRightComponent={
        <MobileRightLoader
          lang={props.lang}
          headerType={props.headerType}
          mobileRightCmsData={mobileRightItems}
        />
      }
      mobileLogoComponent={<MobileLogoLoader lang={props.lang} />}
      mobileTopComponent={
        <MobileTopLoader
          lang={props.lang}
          headerType={props.headerType}
          mobileTopCmsData={mobileTopItems}
        />
      }
      mobileBottomComponent={
        <MobileBottomLoader
          lang={props.lang}
          headerType={props.headerType}
          mobileBottomCmsData={mobileBottomItems}
        />
      }
      currentPath={router.asPath}
    />
  );
};

interface Props {
  headerItems?: IContent.HeaderItemsResponse;
  headerType: "student" | "teacher" | "school";
  lang: "tr" | "en";
}
